import React, { useContext } from "react";
import { OBJECT_TYPE } from "common/constants";
import { GetWorkflowQuery } from "../../generated/graphql";
import { spacing } from "../../stitches.config";
import { AuthContext } from "../Authorization/AuthContext";
import { FlexRow } from "../Common/__styles__/Layout";
import { Icon } from "../Common/Icons/LucideIcons";
import { Tag } from "../Common/Tag";
import { WorkflowStepContainer } from "./__styles__/WorkflowStep";
import { WorkflowStepActions } from "./WorkflowStepActions";
import { WorkflowStepCTA } from "./WorkflowStepCTA";
import { getWorkflowStepStatusDisplay } from "./workflowUtils";

export const WorkflowStep = ({
  workflowStep,
  isManualMode,
  objectId,
  objectType,
}: {
  workflowStep: Omit<
    NonNullable<GetWorkflowQuery["workflow"]>["workflowSteps"][number],
    "status"
  >;
  isManualMode: boolean;
  objectId?: string;
  objectType?: OBJECT_TYPE;
}) => {
  const { isPublic } = useContext(AuthContext);

  const statusTagInfo =
    isManualMode ?
      getWorkflowStepStatusDisplay(workflowStep.manualStatus)
    : undefined;

  return (
    <WorkflowStepContainer>
      <FlexRow style={{ gap: spacing.s.value, alignItems: "center" }}>
        <Icon
          iconName="file-text"
          color="contentSecondary"
          size={15}
          style={{
            flexShrink: 0,
          }}
        />
        {workflowStep.workflowStepDefinition.submissionType.name}
      </FlexRow>
      <FlexRow style={{ gap: spacing.l.value, alignItems: "center" }}>
        {workflowStep.workflowStepUser?.tag && !isManualMode && (
          <Tag styleVariant="default" data-testid="workflow-step-tag">
            {workflowStep.workflowStepUser?.tag}
          </Tag>
        )}
        {statusTagInfo && (
          <Tag
            styleVariant={statusTagInfo.variant}
            data-testid="workflow-step-status-tag"
          >
            {statusTagInfo.text}
          </Tag>
        )}
        <WorkflowStepCTA
          workflowStep={workflowStep}
          objectId={objectId}
          objectType={objectType}
          isManualMode={isManualMode}
        />
        {isManualMode && !isPublic && (
          <WorkflowStepActions
            workflowStepId={workflowStep.id}
            workflowStepManualStatus={workflowStep.manualStatus}
            submissionTypeName={
              workflowStep.workflowStepDefinition.submissionType.name
            }
          />
        )}
      </FlexRow>
    </WorkflowStepContainer>
  );
};
